import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  IFinanceMonthTransferPayoffPayload,
} from '@modules/finance/submodules/month-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  FINANCE_LIST_QUERY_KEY,
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { useToastStore } from '@modules/toast/store';
import { isString } from '@utils/guards';

import {
  FINANCE_MONTH_LIST_QUERY_KEY,
  FINANCE_MONTH_TRANSFER_PAYOFF_MUTATION_KEY,
  FINANCE_MONTH_TRANSFER_PAYOFF_URL,
} from '../constants';

export default function useTransferPayoffFinanceMonthMutation(): IContextMutationResult<
  void,
  Error,
  IFinanceMonthTransferPayoffPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IFinanceMonthTransferPayoffPayload>({
    mutationKey: [FINANCE_MONTH_TRANSFER_PAYOFF_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      FINANCE_MONTH_TRANSFER_PAYOFF_URL,
      payload,
      { permission: FINANCE_PERMISSIONS.TRANSFER_PAYOFF },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          FINANCE_MONTH_LIST_QUERY_KEY,
          FINANCE_LIST_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
      displayPresetToast('success');
    },
  });
}
